import { Bell, Mail, MessageCircle, Smartphone, type LucideIcon } from 'lucide-react';

/** Canal de disparo, no valor que o legado grava em `tipo_disparo`. */
export type DispatchChannel = 'push' | 'email' | 'sms' | 'whatsapp';

export interface ChannelMeta {
  /** Nome fixo em todo lugar: menu, card, agenda e log. */
  label: string;
  icon: LucideIcon;
}

/**
 * Um nome por canal, para o painel inteiro. Antes havia três mapas iguais
 * (card de campanha, agenda e log de disparos) e cada tela escrevia o seu.
 */
export const CHANNEL_META: Record<DispatchChannel, ChannelMeta> = {
  push: { label: 'Push', icon: Bell },
  email: { label: 'E-mail', icon: Mail },
  sms: { label: 'SMS', icon: Smartphone },
  whatsapp: { label: 'WhatsApp', icon: MessageCircle },
};

export const DISPATCH_CHANNELS = Object.keys(CHANNEL_META) as DispatchChannel[];

export function isDispatchChannel(value: unknown): value is DispatchChannel {
  return typeof value === 'string' && value in CHANNEL_META;
}

/** Rótulo do canal; valor desconhecido volta como veio, vazio vira ''. */
export function channelLabel(value?: string | null): string {
  if (!value) return '';
  return isDispatchChannel(value) ? CHANNEL_META[value].label : value;
}
